export default __webpack_public_path__ + "static/gatlinburg-logo-dark-23f7b9f262d2dded4901e0e463a25070.png";